import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { call, put, takeLatest } from "redux-saga/effects";
import { dongBoApi } from "../../../api/dong-bo/dongBoApi";
import { IDongBoPhiKyTucXaRequest } from "../../../model/request/dong-bo/IDongBoPhiKyTucXaRequest";
import { IDongBoPhiKyTucXaSinhVien } from "../../../model/respone/dong-bo/IDongBoPhiKyTucXaSinhVien";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDongBoPhiKyTucXaActionTypeIds,
  IDongBoPhiKyTucXaActionTypes,
} from "../../action-types/dong-bo/IDongBoPhiKyTucXaAction";
import { rootActions } from "../../actions/rootActions";
import { appConst } from "../../../AppConst";

export function* dongBoPhiKyTucXaSaga(): any {
  yield takeLatest(eDongBoPhiKyTucXaActionTypeIds.LOAD_START, loadWorker);
  yield takeLatest(eDongBoPhiKyTucXaActionTypeIds.SYNC_START, syncWorker);
}

function* loadWorker(action: IDongBoPhiKyTucXaActionTypes): any {
  const request = action.payload as IDongBoPhiKyTucXaRequest;

  const result: any = yield call(getTienPhong, request.hoc_ky, request.nam_hoc);
  const data = result.data as IDongBoPhiKyTucXaSinhVien[];
  console.log(data);
  if (result.status) yield put(rootActions.dongBo.kyTucXa.LOAD_SUCCESS(data));
  else
    yield put(
      rootActions.dongBo.kyTucXa.LOAD_ERRR(
        result.message ?? "Có lỗi xảy ra khi tải dữ liệu"
      )
    );
}

// Hàm gọi API bình thường
async function getTienPhong(hoc_ky: number, nam_hoc: string) {
  try {
    const url = `${appConst.URL_KY_TUC_XA}/hoc-ky/${hoc_ky}/nam-hoc/${nam_hoc}`;
    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      return [];
    }

    const data = await response.json();
    return data;
  } catch (error) {
    return [];
  }
}

function* syncWorker(action: IDongBoPhiKyTucXaActionTypes): any {
  const request = action.payload as IProcessRequest<
    IDongBoPhiKyTucXaSinhVien[]
  >;
  const res: IBaseRespone = yield call(dongBoApi.SyncKyTucXa, request);
  if (res.is_success) {
    yield put(rootActions.dongBo.kyTucXa.SYNC_SUCCESS("Đồng bộ thành công"));
  } else {
    yield put(rootActions.dongBo.kyTucXa.SYNC_ERR(res.message ?? "Có lỗi"));
  }
}
